export class ChecklistFlagInfo {
    /* public readonly string */ flagged = false;
    /* public readonly string */ reason = '';

    constructor(flagged, reason) {
        this.reason = reason;
        this.flagged = flagged;
    }
}
